import React from 'react'
import * as styles from './contactForm.module.css'

const ContactForm = () => {
  return (
    <form
      name="Contact Form"
      method="POST"
      data-netlify="true"
      action="/thank-you"
      className={styles.form}
    >
      <h3>Оставьте Ваши контакты</h3>
      <input type="hidden" name="form-name" value="Contact Form" />
      <input type="text" placeholder="Имя" name="name" required />
      <input
        type="number"
        placeholder="Номер телефона"
        name="number"
        required
        autoComplete="something-unsupported"
      />
      <button type="submit">Отправить</button>
      <span>
        Нажимая на кнопку, Вы соглашаетесь с обработкой персональных данных
      </span>
    </form>
  )
}

export default ContactForm
